import ConfirmSignup from "@/pages/ConfirmSignup";
import HalfaCard from "@/pages/HalfaCard";
import ShopPortal from "@/pages/ShopPortal";
import ChangePassword from "@/pages/ChangePassword";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import { MetaProvider } from "@/lib/meta";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductEditor from "@/pages/ProductEditor";
import Cart from "@/pages/Cart";
import Login, { ResetPassword } from "@/pages/Login";
import Account from "@/pages/Account";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { AdminLayout, AdminOrders, AdminOrderDetail } from "@/pages/admin/AdminOrders";
import { AdminProducts, AdminProductEdit } from "@/pages/admin/AdminProducts";
import { AdminSettings } from "@/pages/admin/AdminMisc";
import { AdminCustomers, AdminCustomerDetail } from "@/pages/admin/AdminCustomers";
import { AdminPriceLists, AdminPriceListEdit } from "@/pages/admin/AdminPriceLists";
import { AdminManagers, AdminImport } from "@/pages/admin/AdminManagersImport";
import { ManagerLayout, ManagerOverview, ManagerShop } from "@/pages/manager/ManagerPanel";
import { AdminTemplates } from "@/pages/admin/AdminTemplates";
import { AdminWithdrawals } from "@/pages/admin/AdminWithdrawals";
import { AdminStats } from "@/pages/admin/AdminStats";
import { AdminShopReport } from "@/pages/admin/AdminShopReport";
import { AdminStampCreator } from "@/pages/admin/AdminStampCreator";
import { AdminSavedStamps } from "@/pages/admin/AdminSavedStamps";
import { AdminCounterOrders } from "@/pages/admin/AdminCounterOrders";
import { AdminCassa } from "@/pages/admin/AdminCassa";
import AdminWarehouse from "@/pages/admin/AdminWarehouse";
import AdminCompat from "@/pages/admin/AdminCompat";
import AdminPendingPrinters from "@/pages/admin/AdminPendingPrinters";
import { PrivacyPage, CookiePage, TermsPage, RefundPage } from "@/pages/Legal";
import WithdrawPage from "@/pages/Withdraw";
import { CookieBanner } from "@/components/CookieBanner";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ForcePassword() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user?.must_change_password && pathname !== "/account/password") return <Navigate to="/account/password" replace />;
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <MetaProvider>
        <AuthProvider>
          <CartProvider>
            <ScrollTop />
            <ForcePassword />
            <div className="min-h-screen flex flex-col">
              <Header />
              <div className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalogo" element={<Catalog />} />
                  <Route path="/timbro/:slug" element={<ProductEditor />} />
                  <Route path="/carrello" element={<Cart />} />
                  <Route path="/accedi" element={<Login />} />
                  <Route path="/conferma-iscrizione" element={<ConfirmSignup />} />
                  <Route path="/reimposta-password" element={<ResetPassword />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/account/negozio" element={<ShopPortal />} />
                  <Route path="/halfacard" element={<HalfaCard />} />
                  <Route path="/account/password" element={<ChangePassword />} />
                  <Route path="/pagamento/successo" element={<PaymentSuccess />} />
                  <Route path="/pagamento/annullato" element={<PaymentCancel />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/cookie-policy" element={<CookiePage />} />
                  <Route path="/termini" element={<TermsPage />} />
                  <Route path="/recesso" element={<RefundPage />} />
                  <Route path="/recesso/modulo" element={<WithdrawPage />} />
                  <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<AdminOrders />} />
                    <Route path="ordini/:id" element={<AdminOrderDetail />} />
                    <Route path="prodotti" element={<AdminProducts />} />
                    <Route path="prodotti/:id" element={<AdminProductEdit />} />
                    <Route path="modelli" element={<AdminTemplates />} />
                    <Route path="crea-timbro" element={<AdminStampCreator />} />
                    <Route path="timbri-salvati" element={<AdminSavedStamps />} />
                    <Route path="ordini-banco" element={<AdminCounterOrders />} />
                    <Route path="cassa" element={<AdminCassa />} />
                    <Route path="magazzino" element={<AdminWarehouse />} />
                    <Route path="compatibilita" element={<AdminCompat />} />
                    <Route path="stampanti-attesa" element={<AdminPendingPrinters />} />
                    <Route path="recessi" element={<AdminWithdrawals />} />
                    <Route path="clienti" element={<AdminCustomers />} />
                    <Route path="clienti/:id" element={<AdminCustomerDetail />} />
                    <Route path="listini" element={<AdminPriceLists />} />
                    <Route path="listini/:id" element={<AdminPriceListEdit />} />
                    <Route path="manager" element={<AdminManagers />} />
                    <Route path="statistiche" element={<AdminStats />} />
                    <Route path="negozi-manager" element={<AdminShopReport />} />
                    <Route path="importa" element={<AdminImport />} />
                    <Route path="impostazioni" element={<AdminSettings />} />
                  </Route>
                  <Route path="/manager" element={<ManagerLayout />}>
                    <Route index element={<ManagerOverview />} />
                    <Route path="negozi/:id" element={<ManagerShop />} />
                  </Route>
                </Routes>
                <CookieBanner />
              </div>
              <Footer />
            </div>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </MetaProvider>
    </BrowserRouter>
  );
}

export default App;
